import { render, staticRenderFns } from "./Dropdown-colaborador.vue?vue&type=template&id=93b5cabc&"
import script from "./Dropdown-colaborador.vue?vue&type=script&lang=js&"
export * from "./Dropdown-colaborador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports